export default __webpack_public_path__ + "static/media/addtocart-icon.9336fe34.svg";